function metricsHelper(value) {
    return value === null || value === void 0 ? void 0 : value.toLowerCase().split(" ").join("-");
}

export { metricsHelper };
//# sourceMappingURL=metricsHelper.esm.js.map
